"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeObjectValues = exports.deSanitizeInputValueString = exports.sanitizeInputValueString = void 0;
var sanitizeInputValueString = function (value) {
    if (value === void 0) { value = ''; }
    if (!value)
        return '';
    return value
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#x27;');
};
exports.sanitizeInputValueString = sanitizeInputValueString;
var deSanitizeInputValueString = function (value) {
    if (value === void 0) { value = ''; }
    if (!value)
        return '';
    return value
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#x27;/gi, "'");
};
exports.deSanitizeInputValueString = deSanitizeInputValueString;
var sanitizeObjectValues = function (entries) {
    if (Object.values(entries).length === 0)
        return null;
    if (typeof entries === 'object') {
        for (var entry in entries) {
            entries[entry] =
                typeof entries[entry] === 'string'
                    ? (0, exports.sanitizeInputValueString)(entries[entry])
                    : entries[entry];
        }
    }
    return entries;
};
exports.sanitizeObjectValues = sanitizeObjectValues;
